import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./NavBar.css";

const sections = ["inicio", "servicios", "contacto"];


const NavBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("inicio");
  const [openServicios, setOpenServicios] = useState(false);

  // Detectar sección visible en landing
  const handleScroll = () => {
    if (location.pathname !== "/") return;

    let current = "inicio";
    const scrollPosition = window.scrollY + window.innerHeight / 3;

    for (let id of sections) {
      const el = document.getElementById(id);
      if (el && scrollPosition >= el.offsetTop) {
        current = id;
      }
    }
    setActiveSection(current);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // inicializar
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  // Scroll seguro a sección, incluso desde otra página
  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/"); // vamos a landing
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 50);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [landingActive, setLandingActive] = useState(true);
  useEffect(() => {
    setLandingActive(location.pathname === "/");
  }, [location.pathname]);

  useEffect(() => {
  if (location.pathname !== "/") {
    setActiveSection(""); 
  }
}, [location.pathname]);



  return (
    <nav className="navBar">
      <a className="navBar__brand" onClick={() => scrollToSection("inicio")}>
        <img src="/img/drontalia1.png" alt="Drontalia" />
        <span>DRONTALIA</span>
      </a>
      <ul>

        <li>
          <a
            className={landingActive && activeSection === "inicio" ? "active" : ""}
            onClick={() => scrollToSection("inicio")}
          >
            Inicio
          </a>
        </li>

        <li className="excepcion">

          <a
            className={activeSection && activeSection === "servicios" ? "active" : ""}
            onClick={() => scrollToSection("servicios")}
          >
            Servicios
          </a>

          <button
            className={`desplegar ${openServicios ? "activo" : ""}`}
            onClick={() => setOpenServicios(!openServicios)}
          >
            ▼
          </button>

          <div className={`submenu ${openServicios ? "open" : ""}`}>

            <NavLink to="/inspecciones" onClick={() => {
              setOpenServicios(false);
              setTimeout(() => {   // esperamos que la página cargue
                const el = document.getElementById("inspecciones");
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }, 50);
            }}>
              Inspecciones técnicas
            </NavLink><br /><br />

            <NavLink to="/soluciones" onClick={() => {
              setOpenServicios(false);
              setTimeout(() => {   // esperamos que la página cargue
                const el = document.getElementById("soluciones");
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }, 50);
            }}>
              Soluciones geoespaciales
            </NavLink><br /><br />

            <NavLink to="/seguridad"
              onClick={() => {
                setOpenServicios(false);
                setTimeout(() => {   // esperamos que la página cargue
                  const el = document.getElementById("seguridad");
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 50);
              }}>
              Seguridad y medioambiente
            </NavLink><br /><br />


          </div>

        </li>

        <li>
          <a
            className={activeSection && activeSection === "contacto" ? "active" : ""}
            onClick={() => scrollToSection("contacto")}
          >
            Contacto
          </a>
        </li>

      </ul>
    </nav>
  );
};

export default NavBar;
